import { useCallback, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

export const useSearchParams = () => {
  const location = useLocation();
  const navigate = useHistory();
  const { hash, pathname, search } = location;

  const searchParams = useMemo(() => {
    const params = new URLSearchParams(search);
    const paramsObj = {};    
    params.forEach((value, key) => {
        paramsObj[key] = value;
    });
    
    return paramsObj;
  }, [search]);

  const setSearchParams = useCallback(
    (newParams) => {
      const urlSearchParams = new URLSearchParams(search);

      Object.entries(newParams).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            urlSearchParams.delete(key);
        } else {
            urlSearchParams.set(key, value);
        }
      });

      navigate.push({
        pathname,
        search: urlSearchParams.toString(),
        hash
      });
      
    },
    [hash, navigate, pathname, search]
  );

  return [searchParams, setSearchParams];
};

export default useSearchParams;